// @flow

import React from "react";
import { connect } from "react-redux";
import classNames from "classnames";

import { Translate } from "@quantum/i18n";

import { type ModoApp, MODO_APP_SERIES } from "../../model";
import { getModoApp } from "../../state";

import RelatorioIcon from "../../assets/app_relatorio.png";
import SeriesIcon from "../../assets/app_series.png";

import "./cabecalho.css";

type Props = {
  className?: ?string,
  modo: ModoApp,
  children?: any,
};

const Cabecalho = ({ className, modo, children }: Props) => {
  const isModoSeries = modo === MODO_APP_SERIES;
  return (
    <div className={classNames("Cabecalho", className)}>
      <div className={"Cabecalho__titulo"}>
        <img alt="Logo" src={isModoSeries ? SeriesIcon : RelatorioIcon} />
        <span className="Cabecalho__texto-titulo">
          {isModoSeries ? (
            <Translate>maiusculas.series</Translate>
          ) : (
            <Translate>maiusculas.relatorio</Translate>
          )}
        </span>
      </div>

      {children}
    </div>
  );
};

export default connect(state => ({ modo: getModoApp(state) }))(Cabecalho);
